/**
 * Íconos del radar (plan 27) — kit 24-grid de puntas redondas (mismo lenguaje
 * que el prototipo debrief-loop). Centralizados acá para que la lista y los
 * sheets compartan el mismo trazo.
 */
import type { ReactNode } from 'react';

function icSvg(size: number, children: ReactNode, sw = 1.8) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

export const IcRadar = ({ size = 15 }: { size?: number }) =>
  icSvg(
    size,
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="4.5" opacity="0.55" />
      <circle cx="12" cy="12" r="0.8" fill="currentColor" />
      <path d="M12 12 L 18 6" />
    </>,
  );

export const IcFocus = ({ size = 15 }: { size?: number }) =>
  icSvg(
    size,
    <>
      <circle cx="12" cy="12" r="6.5" />
      <path d="M12 2.8 V 5.5 M 12 18.5 V 21.2 M 2.8 12 H 5.5 M 18.5 12 H 21.2" />
      <circle cx="12" cy="12" r="1" fill="currentColor" />
    </>,
  );

export const IcDone = ({ size = 15 }: { size?: number }) =>
  icSvg(
    size,
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M8 12.5 L 11 15.5 L 16.5 9" strokeWidth="2.2" />
    </>,
  );

export const IcDismiss = ({ size = 15 }: { size?: number }) =>
  icSvg(
    size,
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M6.5 6.5 L 17.5 17.5" />
    </>,
  );

export const IcUndo = ({ size = 13 }: { size?: number }) =>
  icSvg(
    size,
    <>
      <path d="M8.5 7 L 4 11 L 8.5 15" />
      <path d="M4 11 H 15 a 5 5 0 0 1 0 10 h -3" />
    </>,
  );

export const IcDots = ({ size = 17 }: { size?: number }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
    <circle cx="5" cy="12" r="1.8" />
    <circle cx="12" cy="12" r="1.8" />
    <circle cx="19" cy="12" r="1.8" />
  </svg>
);

export const IcClose = ({ size = 16 }: { size?: number }) =>
  icSvg(size, <path d="M6 6 L 18 18 M 18 6 L 6 18" />, 2);

export const IcHelp = ({ size = 16 }: { size?: number }) =>
  icSvg(
    size,
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.2 9.3 a 2.8 2.8 0 0 1 5.3 1.2 c 0 1.9 -2.5 2.2 -2.5 3.8" />
      <circle cx="12" cy="17.2" r="0.9" fill="currentColor" stroke="none" />
    </>,
  );

export const IcArrowR = ({ size = 12 }: { size?: number }) =>
  icSvg(size, <path d="M5 12 H 19 M 13 6 L 19 12 L 13 18" />, 2);

export const IcChevR = ({ size = 16 }: { size?: number }) =>
  icSvg(size, <path d="M9 5 L 16 12 L 9 19" />, 2.2);

export const IcWave = ({ size = 16 }: { size?: number }) =>
  icSvg(
    size,
    <path d="M3 12 H 5 M 8 7 V 17 M 12 4 V 20 M 16 8 V 16 M 20 11 H 21 M 20 11 V 13" />,
    2,
  );

export const IcBook = ({ size = 15 }: { size?: number }) =>
  icSvg(
    size,
    <>
      <path d="M4 5.5 a 2 2 0 0 1 2 -2 H 11 V 19 H 6 a 2 2 0 0 0 -2 2 Z" />
      <path d="M20 5.5 a 2 2 0 0 0 -2 -2 H 13 V 19 H 18 a 2 2 0 0 1 2 2 Z" />
    </>,
  );

export const IcCheck = ({ size = 13 }: { size?: number }) =>
  icSvg(size, <path d="M5 12.5 L 10 17 L 19 6.5" />, 2.2);

export const IcRetry = ({ size = 13 }: { size?: number }) =>
  icSvg(
    size,
    <>
      <path d="M20 8 a 8 8 0 1 0 1 6" />
      <path d="M20 3 V 8 H 15" />
    </>,
  );

export const IcDodge = ({ size = 13 }: { size?: number }) =>
  icSvg(size, <path d="M5 19 C 9 5, 15 5, 19 19 M 5 19 H 19" opacity="0.95" />);

export const IcMoon = ({ size = 13 }: { size?: number }) =>
  icSvg(size, <path d="M20 14.5 A 8 8 0 1 1 9.5 4 a 6.2 6.2 0 0 0 10.5 10.5 Z" />);

export const IcClock = ({ size = 13 }: { size?: number }) =>
  icSvg(
    size,
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5 V 12 L 15 14" />
    </>,
  );
